import { useState } from 'react';
import { legalFormStep7FieldNames } from '../../components/LegalForm/steps/step7/utils';

const {
  FORM_TYPE,
  SMS_SERVICE,
  INTERNET_BANK,
  CURRENCY,
  STREET,
  // CARD_INFO_MAIN_CURRENCY,
  // CARD_INFO_DELIVERY_METHOD,
  CARD_INFO_BRANCH_ID,
  CARD_INFO_DELIVERY_CITY,
  CARD_INFO_DELIVERY_STREET,
  CARD_INFO_DELIVERY_HOME_NUMBER,
  CARD_INFO_DELIVERY_APARTMENT_NUMBER,
  // CARD_INFO_CURRENCY,
} = legalFormStep7FieldNames;

const initialValues = {
  [FORM_TYPE]: '',
  [SMS_SERVICE]: '',
  [INTERNET_BANK]: '',
  [CURRENCY]: [0],
  [STREET]: '',
  // [CARD_INFO_MAIN_CURRENCY]: 'GEL',
  // [CARD_INFO_CURRENCY]: [0],
  // [CARD_INFO_DELIVERY_METHOD]: '',
  [CARD_INFO_BRANCH_ID]: '',
  [CARD_INFO_DELIVERY_CITY]: 1243,
  [CARD_INFO_DELIVERY_STREET]: '',
  [CARD_INFO_DELIVERY_HOME_NUMBER]: '',
  [CARD_INFO_DELIVERY_APARTMENT_NUMBER]: '',
};

function useStepSevenValues() {
  const [stepSevenValues, setStepSevenValues] = useState(initialValues);
  return { stepSevenValues, setStepSevenValues, initialValues };
}

export default useStepSevenValues;
